import { defaultPrimitive, HTMLContent, ILandingPrimitive, LANDING_TYPE_CONTENT, MarriageContent } from "src/modules/pe-landing-module/data/interfaces"
import Floats from "../section/floats/Floats"
import { IPrimitiveProps } from "../section/Primitive"
import { useEffect, useState } from "react"
import { getCssDemention } from "src/libs/utilities"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import mirrages from "src/modules/pe-landing-module/data/utils/mirrages"

/* Protopia Ecosystem component */
const MarriagePrimitive = (props: IPrimitiveProps): JSX.Element => {
    const primitive: MarriageContent  = ( props.primitive || {} ) as MarriageContent
    const text: HTMLContent = primitive.text || {} as HTMLContent
    const [height, ] = useState<string>(getCssDemention( primitive.height, "fit-content" ))
    useEffect(() => {
        addCSSClass(
            `canvas-${primitive.id}`,
            `.canvas-${primitive.id} { 
                height: ${ height };
                z-index:1;
            } `
        ) 
        return () => {
            removeCSSClass(`canvas-${ primitive.id}`)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])  
 

    const positions: any = mirrages()[ primitive.design_type || 0 ]

    let floats: (ILandingPrimitive | any)[] = Array(10).fill(0).map((item, i) => {
        return {
            id: `${primitive.id}-${i}-image`,
            // parallax_speed: -0.10,
            // parallax_y_offset: -320,
            // effect: "vparallax",
            className: "",
            position: {
                top : positions["image" + i]?.position.top,
                left: positions["image" + i]?.position.left,
                width: positions["image" + i]?.position.width,
                height: positions["image" + i]?.position.height,
            },
            "primitives": [ 
                {
                    ...defaultPrimitive(),
                    id: `${primitive.id}-${i}-image`,
                    type: LANDING_TYPE_CONTENT.IMAGE,
                    "data-primitive-type": LANDING_TYPE_CONTENT.IMAGE,
                    className: "",
                    hover_size: primitive.hover_size,
                    style: {
                        ...( primitive[ "image" + i ].style   || primitive.imageStyle ),
                        ...( primitive[ "image" + i ].border  || primitive.imageBorder ),
                        backgroundColor: "#508750",
                        boxShadow: "0 13px 22px 0 #00000066, 0 2px 5px #000000EE"
                    },
                    data:  primitive[ "image" + i ],
                    position: {
                        width:      positions["image" + i]?.position.width,
                        height:     positions["image" + i]?.position.height,
                        opacity:    positions["image" + i]?.position.opacity,
                        rotate:     positions["image" + i]?.position.rotate
                    }
                }
            ]
        }
    }) 
    
    floats = [
        {
            id: `${primitive.id}-html`,
            // parallax_speed: -0.10,
            // parallax_y_offset: -320,
            // effect: "vparallax",
            className: "",
            position: {
                top : positions.text.position.top,
                left: positions.text.position.left
            },
            primitives: [
                {
                    ...defaultPrimitive(),
                    ...text,
                    id:`${primitive.id}-1-html`,
                    type: LANDING_TYPE_CONTENT.HTML,
                    "data-primitive-type": LANDING_TYPE_CONTENT.HTML,
                    className: "p-2", 
                    style: { 
                        backgroundColor: "var(--force-plain-secondary-opacity-color)"
                    }, 
                    max_length: 650,
                    // text : text.text,
                    // link_url: text.link_url,
                    // link_target: text.link_target,
                    // textSize: text.textSize,
                    position: {
                        width:      positions.text.position.width,
                        height:     positions.text.position.height,
                        opacity:    positions.text.position.opacity,
                        rotate:     positions.text.position.rotate
                    }
                } 
            ]
        },
        ...floats,
    ]

    return <div 
        role="article" 
        className={` landing-canvas canvas-${ primitive.id }`}
        style={ primitive.data?.style }
        data-primitive-type={primitive["data-primitive-type"]}
    >
        <Floats 
            floats={ floats } 
            animated={primitive.animated} 
            animated_delay={primitive.animated_delay} 
        />
    </div>
}
export default MarriagePrimitive
